import Textarea from "./textarea";

export { Textarea };
export default Textarea;
